/*    
<summary>
  This functional component "AddOptionMenu" defines the props like initial values and functions for the child form component.
  Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
<returns>Returns JSX</returns>
*/

import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";

import userTypeEnum from "../../../../constants/enums/user-type-enum";
import { useStore } from "../../../../contexts/store-provider";
import { getStoreIdFromLocalStorage, getUserTypeFromLocalStorage } from "../../../../helpers/localstorage-helper";
import { IAddCustomer } from "../../../../models/forms/IAddCustomerManagement";
import { formatMessage } from "../../../../translations/format-message";
import ProfileForm from "../forms/add-edit-profie-form";
import { AuthStore } from "../../../../core/stores/auth-store";

const AddEditProfile = (props: any) => {
  const { authStore, customerManagementStore, storeManagementStore } =
    useStore();

  const { logout } = authStore;
  const {
    inProgress,
    GetCustomerByIdService,
    resetAddUpdateCustomerState,
    resetCustomerDetail,
    customerState,
    customerDetail,
    addUpdateCustomerState,
    AddCustomerService,
    UpdateCustomerService,
    deleteCustomerState,
    DeleteCustomerService,
    resetDeleteCustomer,
  } = customerManagementStore;

  const { storeState, resetPrefectureByZipCode } = storeManagementStore;

  const initialValues: IAddCustomer = {
    ...customerDetail,
    Password: "*********",
  };

  const customerId = props.id ?? localStorage.getItem("lizera_userId");

  // useEffect(() => {
  //   if (customerId) {
  //     let storeId = getStoreIdFromLocalStorage();
  //     GetCustomerByIdService(customerId, storeId > 0 ? storeId : null);
  //   }
  // }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "customerDetailError" of the useEffect changed.
   */
  useEffect(() => {
    if (customerState.error) {
      toast.error(formatMessage(customerState.error));
    }
  }, [customerState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateCustomerError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateCustomerState.error) {
      toast.error(formatMessage(addUpdateCustomerState.error));
      resetAddUpdateCustomerState();
    }
  }, [addUpdateCustomerState.error]);

  useEffect(() => {
    if (addUpdateCustomerState.success) {
      toast.success(formatMessage("updated_success"));
      resetAddUpdateCustomerState();
      resetPrefectureByZipCode();
    }
  }, [addUpdateCustomerState.success]);

    useEffect(() => {
    if (deleteCustomerState.success) {
      new AuthStore().logout();
    }
  }, [deleteCustomerState.success]);

  /**
   * This function adds the customer when "Id < 0" and updates the Existing customer when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = async (values: any) => {
    let tempValues = cloneDeep(values);
    await UpdateCustomerService(Number(customerId), tempValues, true);
    // GetCustomerByIdService(customerId);
    // toast.success(formatMessage("updated_success"));
  };

  const handleDeleteSubmitHandler = () => {
    DeleteCustomerService(customerId);
  };

  useEffect(() => {
    if (deleteCustomerState.success) {
      toast.success(formatMessage("account_deleted_success"));
      logout();
      resetDeleteCustomer();
    }
  }, [deleteCustomerState.success]);

  return (
    <React.Fragment>
      <ProfileForm
        initialValues={initialValues}
        id={customerId}
        submitHandler={onSubmitForm}
        getCustomerLoading={
          customerState.inProgress ||
          addUpdateCustomerState.inProgress ||
          storeState.inProgress ||
          inProgress
        }
        handleDeleteSubmitHandler={handleDeleteSubmitHandler}
        deleteActionLoading={deleteCustomerState.inProgress}
      />
    </React.Fragment>
  );
};

export default observer(AddEditProfile);
